export enum OccurrenceUnit {
  KILOMETER = 'kilometer',
  HOUR = 'hour',
}
